import React from 'react'
import DynamicItemViewPage from './DynamicItemViewPage'

interface IDynamicElementQuickPreviewProps {
    elemId: number,
    pageName: string,
}

export default function DynamicElementQuickPreview(props: IDynamicElementQuickPreviewProps) {
    return <DynamicItemViewPage customId={props.elemId} hidePageSection={false} customPage={props.pageName} />
}